import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setMenuCollapsed,
  setSubMenuCollapsed,
  setAdminSearchResults,
  setAlliances,
} from '../redux/actions/generalActions';
import { setGolfClubDetails } from '../redux/actions/golfClubActions';
import { Layout, Button, Affix, AutoComplete, Row, Col, Input } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import greenfeeDealsApi from '../api/greenfeeDeals';
const { Header } = Layout;

function HeaderComponent() {
  const golfClubDetails = useSelector(
    (state) => state.golfClub.golfClubDetails,
  );
  const dispatch = useDispatch();
  const menuCollapsed = useSelector((state) => state.general.menuCollapsed);
  const sessionBnd = localStorage.getItem('sessionBnd');
  const headers = {
    headers: { Authorization: `Bearer ${sessionBnd}` },
  };

  const userDetails = useSelector((state) => state.general.userDetails);
  const userRole = userDetails?.role;
  const adminSearchResults = useSelector(
    (state) => state.general.adminSearchResults,
  );

  const toggleCollapsed = () => {
    const collapsed = !menuCollapsed;
    dispatch(setMenuCollapsed(collapsed));
    if (collapsed === true) {
      dispatch(setSubMenuCollapsed([]));
    }
  };

  const searchGolfClubs = async (values) => {
    try {
      if (values.length > 3) {
        const response = await greenfeeDealsApi.get(
          `golfclubs?name[regex]=(?i)${values}`,
          headers,
        );
        const apiResult = response.data.data.data;
        const resultsList = [];
        apiResult.forEach((e) => {
          resultsList.push({
            key: e._id,
            value: e.name,
          });
        });

        dispatch(setAdminSearchResults(resultsList));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleLogout = async () => {
    try {
      await greenfeeDealsApi.get('/logout'); // calls backend logout
    } catch (error) {
      console.log('Logout error:', error);
    }

    // Clear localStorage
    localStorage.removeItem('sessionBnd');

    // Redirect to login page
    window.location.href = '/';
  };

  const changeGolfClub = async (values) => {
    const golfClubId = values.key;

    const golfClub = await greenfeeDealsApi.post(
      `/golfclubs/golfClubAdmin`,
      { id: golfClubId },
      headers,
    );
    if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
      console.log('Error no Golfclub found for your Admin Account');
      return;
    }
    const results = golfClub.data.data.data;
    dispatch(setGolfClubDetails(results));
    console.log('RESULT OF GOLF CLUDBB:::::---->>>>>', results);
    // dispatch(setAlliances(results?.alliances));
    // window.location.reload();
  };

  return (
    <div style={{ backgroundColor: 'white' }}>
      <Affix offsetTop={0}>
        <Header
          style={{
            backgroundColor: 'white',
            paddingLeft: 50,
            paddingBlock: 17,
            borderBottom: '1px solid #00000010',
          }}
        >
          <Row>
            <Col
              span={12}
              style={{ display: 'flex', alignItems: 'center', gap: 15 }}
            >
              <Button type="primary" onClick={toggleCollapsed}>
                {React.createElement(
                  menuCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                )}
              </Button>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 20,
                  fontFamily: 'DM Sans',
                  color: '#222222',
                  lineHeight: 'normal',
                }}
              >
                {golfClubDetails.name}{' '}
                {(userRole === 'admin' ||
                  userRole === 'dealAdmin' ||
                  userRole === 'subAdmin') && (
                  <p style={{ color: '#628478', fontSize: 12, margin: 0 }}>
                    {golfClubDetails._id.golfClub}
                  </p>
                )}
              </div>
            </Col>

            <Col
              justify="end"
              align="end"
              span={12}
              style={{ position: 'relative' }}
            >
              {(userRole === 'admin' || userRole === 'dealAdmin') && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                  }}
                >
                  <span
                    style={{
                      position: 'relative',
                      right: -32,
                      zIndex: 999,
                      marginBottom: 2,
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                        stroke="#628478"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14 14L11.1333 11.1333"
                        stroke="#628478"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <AutoComplete
                    onChange={searchGolfClubs}
                    onSelect={(key, both) => changeGolfClub(both)}
                    className="search-bar-clss "
                    style={{
                      maxWidth: 300,
                      width: '100%',
                      textAlign: 'start',
                      paddingLeft: 30,
                      height: 40,
                      backgroundColor: '#F6F8F7',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: 11,
                      // marginInlineStart: 'auto'
                    }}
                    options={adminSearchResults}
                    placeholder="Suche..."
                  />
                </div>
              )}
              {/* <Button
                type="primary"
                danger
                onClick={handleLogout}
                style={{ marginLeft: 20 }}
              >
                Logout
              </Button> */}
            </Col>
          </Row>
        </Header>
      </Affix>
    </div>
  );
}

export default HeaderComponent;
